import { render } from "./DeleteAnswerModal.vue?vue&type=template&id=0a3c38a8"
import script from "./DeleteAnswerModal.vue?vue&type=script&lang=js"
export * from "./DeleteAnswerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__